import select from 'dom-select';
import { toggle, refresh } from '@components/expandable/expandable.init';

export const CookieConsent = (el) => {
  const ui = {
    el,
    allow: select('.button#allow-cookies', el),
    learn: select('.button#learn-cookies', el),
    deny: select('.button#deny-cookies', el),
    details: select('.cookie-consent__details', el),
    primary: select('.cookie-consent__primary', el),
    expandable: select('.expandable', el)
  };

  const animateButtons = () => {
    ui.learn.classList.add('is-hidden');

    setTimeout(() => {
      ui.learn.setAttribute('hidden', true);
      ui.deny.removeAttribute('hidden');
      ui.deny.classList.remove('is-hidden');
    }, 200);
  };

  const animateContent = () => {
    ui.primary.classList.add('is-hidden');
    ui.primary.setAttribute('hidden', true);
    ui.details.removeAttribute('hidden');
    ui.details.classList.remove('is-hidden');
    ui.expandable.dispatchEvent(refresh);
  };

  const revealBanner = () => {
    ui.el.removeAttribute('hidden');
    ui.expandable.dispatchEvent(toggle);

    setTimeout(() => {
      ui.el.classList.remove('off-screen');
    }, 300);
  };

  const dismissBanner = () => {
    ui.el.classList.add('is-hidden');

    setTimeout(() => {
      ui.el.setAttribute('hidden', true);
    }, 300);
  };

  const addEventListeners = () => {
    ui.allow.addEventListener('click', () => {
      dismissBanner();

      /*
        setCookie();
      */
    });

    ui.deny.addEventListener('click', () => {
      dismissBanner();
    });

    if (ui.learn !== null) {
      ui.learn.addEventListener('click', () => {
        animateButtons();
        animateContent();
      });
    }
  };

  const init = () => {
    /* 
      if (!getCookie()) {
        setTimeout(() => {
          revealBanner();
        }, 3000);

        addEventListeners();
      }
    */

    setTimeout(() => {
      revealBanner();
    }, 1500);

    addEventListeners();
  };

  init();
};

export default CookieConsent;
